import { IEntity, IPagedSearchParams } from '@pf/shared-common';
import {
    AsnLineSearchRequestParams,
    AsnLineViewModelCreateBody,
    AsnLineViewModelRead,
    AsnStatus,
    ItemDimension,
    ItemFragment,
    LocationFragment,
    Weight,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';

export type AsnLineRead = AsnLineViewModelRead & IEntity;
export type AsnLineCreate = AsnLineViewModelCreateBody;
export type AsnLineSearchParams = AsnLineSearchRequestParams & {
    asnHeaderId?: string | null;
} & IPagedSearchParams;

export class AsnLineDto implements IEntity {
    constructor(data: Partial<AsnLineDto>) {
        Object.assign(this, data);
    }
    id!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    vendorLPN?: string | null;
    vendorParentLPN?: string | null;
    quantity?: number;
    containerType?: string | null;
    itemSerialNumber?: string | null;
    purchaseOrderLineId?: string | null;
    externalReferenceId?: string | null;
    lineNumber?: number | null;
    status?: AsnStatus;
    item?: ItemFragment;
    reservedForLocation?: LocationFragment;
    asnHeaderId?: string | null;
    customFields?: Array<CustomFieldDto> | null;
    weight?: Weight;
    dimensions?: ItemDimension;
}
